export default {
	SCORM_INIT_FAILED: {
		code: "SCORM_INIT_FAILED",
		message: "Peristence initialization failed, unable to connect to LMS."
	},
	SCORM_SAVE_FAILED: {
		code: 'SCORM_SAVE_FAILED',
		message: 'Save call to SCORM LMS failed.'
	},
	SCORM_SET_FAILED: {
		code: 'SCORM_SET_FAILED',
		message: (params) => `Set call to SCORM LMS failed, path: ${params.path}, value: ${params.value}`
	}



}